import { UserTypes } from "../../../interfaces";
import { axios } from "../../../lib/axios";
import { API_ROUTES } from "../../../lib/constants";


export const list = (params: any): Promise<any> => {
	return axios.get(
		API_ROUTES.USERS.GET,
		{ params }
	);
}

export const update = (paylaod: UserTypes.UserUpdatePayload): Promise<UserTypes.UserListResponse> => {
	return axios.patch(
		API_ROUTES.USERS.LIST,
		paylaod
	);
}


export const specificCMS = (type: number): Promise<any> => {
	return axios.get(
		"/cms",
		{ params: { type } }
	);
}


export const addUser = (payload: any): Promise<any> => {
	return axios.post(
		API_ROUTES.USERS.LIST,
		payload
	);
}
export const updateUser = (id:any,payload: any): Promise<any> => {
	return axios.put(
		API_ROUTES.USERS.LIST + `/${id}`,
		payload
	);
}
export const getUser = (id:any): Promise<any> => {
	return axios.get(
		API_ROUTES.USERS.LIST + `/${id}`,
	);
}